import object from '@mailobj-browser/front/js/utils/object.js'

const block = 'ea_calendar'
const blockEvent = `${block}__event`
const blockEventResources = `${blockEvent}_resources`

export const elements = object(null, {
  event: blockEvent,
  eventRepeat: `${blockEvent}_repeat`,
  eventRepeatAdd: `${blockEvent}_repeat_add`,
  eventRepeatDelete: `${blockEvent}_repeat_delete`,
  eventRepeatTile: `${blockEvent}_repeat_tile`,
  eventScheduleEndDate: `${blockEvent}_schedule_end_date`,
  eventScheduleStartDate: `${blockEvent}_schedule_start_date`,
  eventScheduleEndTime: `${blockEvent}_schedule_end_time`,
  eventScheduleStartTime: `${blockEvent}_schedule_start_time`,
  resources: blockEventResources,
  resourcesList: `${blockEventResources}_list`,
  resourcesModal: `${blockEventResources}_modal`,
  resourcesOpenerAdd: `${blockEventResources}_opener_add`,
  resourcesOpenerEmpty: `${blockEventResources}_opener_empty`,
  // resourcesModalAvailability: `${blockEventResources}_modal_availability`,
  schedule: `${block}__schedule`,
})
